<mat-icon
  class="icon"
  aria-hidden="false"
  aria-label="icon"
  [ngClass]="iconClassNames"
  [ngStyle]="getStyles()"
  (click)="onClick()"
  > {{ name }}</mat-icon>
